/**
 * Alert visivo per fatture passive senza ordine abbinato.
 *
 * Mostrato nella lista e nel dettaglio fatture quando
 * abbinamento_stato = 'in_attesa_manuale'. Usa esclusivamente
 * i componenti e token di @floraltech/ui (regola 6.8 CLAUDE.md).
 */

import { Alert, AlertDescription, AlertTitle } from '@floraltech/ui';
import React from 'react';

interface AbbinamentoAlertProps {
  /** ID della fattura (per azioni future come trigger abbinamento manuale). */
  fatturaId: string;
  /** Classe CSS aggiuntiva opzionale. */
  className?: string;
}

/**
 * Alert mostrato quando una fattura passiva non ha un ordine abbinato.
 * Informa l'operatore che è richiesto un abbinamento manuale.
 *
 * @param fatturaId - UUID della fattura da abbinare.
 * @param className - Classe CSS aggiuntiva.
 */
const AbbinamentoAlert: React.FC<AbbinamentoAlertProps> = ({
  fatturaId,
  className,
}) => {
  return (
    <Alert variant="warning" className={className}>
      <AlertTitle>Abbinamento ordine richiesto</AlertTitle>
      <AlertDescription>
        Questa fattura passiva non è stata abbinata automaticamente a nessun
        ordine. Verificare il documento e procedere con l&apos;abbinamento
        manuale prima di approvare il pagamento.
      </AlertDescription>
    </Alert>
  );
};

export default AbbinamentoAlert;
